export const baseUrlDev = 'http://localhost:5000/api/v1';
// export const baseUrlPro = 'https://soba-api.soba.africa/api/v1';
export const baseUrlPro = 'https://apinode.soba.africa/api/v1';